import React, {ReactElement} from 'react'
import Head from 'next/head'
import {PageMeta, TranslatedEntry} from '../../types'
import {getValidHrefLanguages} from '../../utils/getValidHrefLanguages'

type HrefLangLinksProps = {
  currentLocale: string
  meta: PageMeta
  translations?: TranslatedEntry[]
}

/**
 * We need to hide hreflang links if a template is not the default language
 * and has a custom canonicalUrl
 *
 * @see https://miro.atlassian.net/browse/RTB-131869
 */
export const HrefLangLinks = ({
  currentLocale,
  meta,
  translations,
}: HrefLangLinksProps): ReactElement => {
  if (!meta.showHrefLangLinks) {
    return null
  }

  const validHrefLanguages = getValidHrefLanguages(currentLocale, translations)

  return (
    <Head>
      {validHrefLanguages.map(({href, hrefLang}) => (
        <link key={hrefLang} rel="alternate" href={href} hrefLang={hrefLang} />
      ))}
    </Head>
  )
}
